import { message } from "antd";
import axios from "axios";
import { create } from "zustand";

export const useCustomers = create((set, get) => ({
    customers: [],
    ed: {},
    setEd: (ed) => set({ ed }),
    customer: {},
    setCustomer: (customer) => set({ customer }),
    // `first_name`, `last_name`, `mobile`, `address`, `balance`, `status`
    columns: [
        {
            title: 'Familya',
            dataIndex: 'last_name',
            key: 'last_name',
        },
        {
            title: 'Ismi',
            dataIndex: 'first_name',
            key: 'first_name',
        },
        {
            title: 'Telefon',
            dataIndex: 'mobile',
            key: 'mobile',
        },
        {
            title: 'Balansi (+ qarz, - ortiqcha summa)',
            dataIndex: 'balance',
            key: 'balance',
        },
        {
            title: 'Manzil',
            dataIndex: 'address',
            key: 'address',
        },
    ],
    fetchCustomers: async () => {
        try {
            const response = await axios.get('/customers');
            set({ customers: response.data });
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    },
    addCustomer: async (customer) => {
        try {
            const response = await axios.post('/customers', customer);
            get().fetchCustomers();
            message.success('Mijoz muvaffaqiyatli qo`shildi');
        } catch (error) {
            console.error('Error adding customer:', error);
        }
    },
    updateCustomer: async (customer) => {
        try {
            const response = await axios.put(`/customers/${customer.id}`, customer);
            get().fetchCustomers();
            message.success('Mijoz muvaffaqiyatli tahrirlandi');
        } catch (error) {
            console.error('Error updating customer:', error);
        }
    },
    deleteCustomer: async (_, id) => {
        try {
            await axios.delete(`/customers/${id.id}`);
            get().fetchCustomers(); 
            message.success('Mijoz muvaffaqiyatli o`chirildi');
        } catch (error) {
            console.error('Error deleting customer:', error);
        }
    },
}))